namespace BlockPuzzle {
    export enum InscriptionLevel {
        GOOD = 'Good',
        GREAT = 'Great',
        EXCELLENT = 'Excellent',
        AWESOME = 'Awesome'
    }
}